import { useEffect } from "react";
import { ScrollView } from "react-native";
import { useAPI } from "../contexts/APIContext.js";
import { useJourney } from "../contexts/JourneyContext.js";
import ContentItemsList from "../elements/ContentItemsList";
import GraphicBackground from "../elements/GraphicBackground.jsx";
import Toolbar from "../elements/Toolbar.js";

export default function ScreenOverture(props) {

  const journeyContext = useJourney();
  const api = useAPI();

  const startedOverture = () => {
    console.log("Overture started");
    api.startedOverture(journeyContext.voyagerCode);
  }
  
  const finishedOverture = () => {
    api.finishedOverture(journeyContext.voyagerCode);
    journeyContext.finishedOverture();
  };

  // Call startedOverture when the component mounts and we have a voyager code
  useEffect(() => {
    if (journeyContext.voyagerCode) {
      startedOverture();
    }
  }, [journeyContext.voyagerCode]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <GraphicBackground source={journeyContext.serverData.background_for_overture} >
      <ScrollView style={{marginTop: 80}}>
        <ContentItemsList 
          contentItems={journeyContext.overtureItems()}
          completionButtonTapped={finishedOverture}
          completionButtonLabel="Start"
        />
      </ScrollView>
      <Toolbar />
    </GraphicBackground>
  );
}